import React from 'react';
import { createUser } from '../../services/apiService'
import { showApiError } from '../utilities'
import { Form, Button, Input, Select } from 'antd';
import { user_roles_source } from '../enums'

const { Option } = Select;
class AddNewUser extends React.Component {

  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };

  handleSubmit = (e) => {
    e.preventDefault();
    //console.log("submitting contributor...");
    this.props.form.validateFields((err, values) => {
      if (!err) {


        const newUser = {
          "username": values.newUserName,
          "email": values.email,
          "password": values.password,
          "role": values.role
        }

        //console.log("new user: ", newUser);

        createUser(newUser)
          .then(json => {
            if (typeof json === 'string') {
              throw new Error(json)
            } else {

              //window.location.href = "/users"
              this.props.history.push('/users')
            }
          })
          .catch(error => {
            showApiError(error)
          })


      } else {
        console.error(err)
      }
    })
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };


  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleRoleChange = value => {
    //console.log("value: " + value )
  };

  render() {

    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 4,
        },
      },
    };


    const role_options = Object.values( user_roles_source )

    //console.log(this.props)
    return (
      <div className="content">
        <h2>{this.props.title}</h2>
        <Form autoComplete="off" className="side-form" onSubmit={this.handleSubmit}  {...formItemLayout}>
          <div className="panel" ></div>

          <Form.Item label="E-mail">
            {getFieldDecorator('email', {
              initialValue: '',
              rules: [
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ],
            })(<Input />)}
          </Form.Item>

          <Form.Item label="New User name">
            {getFieldDecorator('newUserName', {
              initialValue: '',
              rules: [{ required: true, message: 'Please input your username!' }],
            })(
              <Input />
            )}
          </Form.Item>

          <Form.Item label="Password" hasFeedback>
            {getFieldDecorator('password', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: 'Please input your password!',
                },
                {
                  validator: this.validateToNextPassword,
                },
              ],
            })(<Input.Password autoComplete="new-password" />)}
          </Form.Item>

          <Form.Item label="Confirm Password" hasFeedback>
            {getFieldDecorator('confirm', {
              rules: [
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                {
                  validator: this.compareToFirstPassword,
                },
              ],
            })(<Input.Password onBlur={this.handleConfirmBlur} autoComplete="none"/>)}
          </Form.Item>

          <Form.Item label="User Role">
            {getFieldDecorator('role', {
              initialValue : role_options[0] ,
              rules: [{ required: true, message: 'Please select the user role!' }],
            })(
              <Select
                placeholder="Select a user role"
                onChange={this.handleRoleChange}
              >
                {
                  role_options.map(r => (
                    <Option key={r}>{r}</Option>
                    )
                  )
                }
              </Select>,
            )}
          </Form.Item>


          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Submit</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
};


const AddUser = Form.create({ name: 'newuser' })(AddNewUser);
export default AddUser;